// 3rd party imports
import * as React from 'react';
import { LocalizedText } from '@shared-ui/localization-context';
import { useStores } from 'hooks';
import { observer } from 'mobx-react';

// ui
import { UitkText, UitkHeading } from 'uitk-react-text';
import { UitkPrimaryButton } from 'uitk-react-button';
import { UitkEmptyState, UitkEmptyStateActionArea } from 'uitk-react-empty-state';
import { UitkSpacing } from 'uitk-react-spacing';

// Utils
import { analyticsEvent } from '../util/analytics';

export const ErrorMessageCJ = observer(() => {
  const { analytics, pzStore, userAuth } = useStores();

  React.useEffect(() => {
    if (pzStore?.pzPublisher?.network_status) {
      analyticsEvent(analytics, userAuth, pzStore, 'affhub.error.cj.presented', 'Affhub Error CJ Presented');
    }
  }, [userAuth?.currentUserDetails, pzStore?.pzPublisher]);

  return (
    <UitkEmptyState fullscreen={true}>
      <UitkHeading size={3} tag="h2">
        <LocalizedText message="error.cj.heading" />
      </UitkHeading>
      <UitkSpacing margin="four">
        <UitkText size={300} theme="default">
          <LocalizedText message="error.cj.body.text" />
        </UitkText>
      </UitkSpacing>
      <UitkEmptyStateActionArea>
        <UitkPrimaryButton
          type="button"
          tag="a"
          href="https://help.affiliates.expediagroup.com/hc/en-us/articles/4410934356887"
          target="_blank"
        >
          <LocalizedText message="error.cj.cta.view_help_article" />
        </UitkPrimaryButton>
      </UitkEmptyStateActionArea>
    </UitkEmptyState>
  );
});
